/** Official Productdeal.com site (Comparison Shopping Service branding). */
export const PRODUCTDEAL_URL = 'https://productdeal.com';
